import React, { useRef } from 'react'
import { useClickAway } from 'react-use'
import classNames from 'classnames'
import Popper from 'transfix-ui/components/Popper'
import {
  IBorderedCarrierScorecardProps,
  BorderedCarrierScorecard,
} from '../BorderedCarrierScorecard/BorderedCarrierScorecard'

export interface ICarrierScorecardPopperProps extends IBorderedCarrierScorecardProps {
  isOpen: boolean
  toggle: () => void
  trigger?: React.ReactNode
}

export const CarrierScorecardPopper: React.FC<ICarrierScorecardPopperProps> = ({
  isOpen,
  toggle,
  trigger,
  ...props
}) => {
  const ref = useRef<HTMLSpanElement | null>(null)

  /**
   * When user clicks away from it
   */
  useClickAway(ref, () => {
    if (isOpen) {
      toggle()
    }
  })

  return (
    <>
      <span ref={ref}>{trigger}</span>
      <Popper open={isOpen} anchorEl={ref.current}>
        <BorderedCarrierScorecard className={classNames('wrapped', 'big')} {...props} />
      </Popper>
    </>
  )
}

export default CarrierScorecardPopper
